import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { Modal } from '@/components/modal/Modal'
import { BrowserContext } from 'context'
import { useContext } from 'react'
import { DealSyncSideBarModalBase } from './DealSyncSideBarModalBase'

interface DealSyncSideBarModalConnectProps {
  isOpen: boolean
  onClose: () => void
}

export const DealSyncSideBarModalConnected = ({
  isOpen,
  onClose,
}: DealSyncSideBarModalConnectProps) => {
  const { isMobile } = useContext(BrowserContext)
  return (
    <Modal
      styles={{
        body: {
          padding: 0,
          background: 'transparent',
        },
        content: {
          background: 'transparent',
          overflow: 'visible',
          minWidth: !isMobile ? '500px' : undefined,
        },
      }}
      centered
      size="md"
      opened={isOpen}
      onClose={onClose}
      withCloseButton={false}
    >
      <DealSyncSideBarModalBase>
        <Title
          variation="regular"
          sizeClass="text-18"
          lineHeightClass="leading-22"
          // weightClass="font-light"
          className="text-center"
        >
          You’re in! We’re scanning your inbox for VIP connections
        </Title>

        <Text className="text-center mt-22">
          <span className="font-bold">What happens now?</span> We’ll start
          connecting you with your top VIPs automatically and let you know when
          they join your network.*
        </Text>
        <div className="flex full-w justify-center mt-22">
          <ButtonComponent
            size="regular"
            label="Sounds great!"
            fullWidth
            onClick={onClose}
          />
        </div>

        <Text className="text-center mt-22 italic" sizeClass="text-15">
          *You can disable auto-connect anytime in settings
        </Text>
      </DealSyncSideBarModalBase>
    </Modal>
  )
}
